<script lang="ts">
	import Formatted from "./Formatted.svelte";

	interface BulletItem {
		text: string;
	}

	const {
		items,
		bulletColor = "bg-zms-blue",
		textSize = "text-sm md:text-base",
		spacing = "space-y-2",
	}: {
		items: BulletItem[];
		bulletColor?: string;
		textSize?: string;
		spacing?: string;
	} = $props();
</script>

<ul class={spacing}>
	{#each items as item (item)}
		<li class="flex items-start gap-3">
			<div class="w-2 h-2 rounded-full {bulletColor} mt-2 shrink-0"></div>
			<span class="text-optical-black {textSize}">
				<Formatted text={item.text} />
			</span>
		</li>
	{/each}
</ul>
